import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    home_title: 'Портал электронных услуг акимата области Жетісу',
    home_subtitle: 'Предоставляемые услуги',
    home: 'Главная',
    home_support: 'Служба поддержки',
    home_frequently_asked_questions: 'Часто задаваемые вопросы',
    home_user_guide: 'Руководство пользователя',
    home_user_video: 'Видеоинструкция пользователя',

    home_insert_title: 'Получите госуслугу быстро, удобно, легко',
    home_insert_text: 'Экономьте ваше время и нервы',
    home_insert_btn: 'Войти в личный кабинет',
    home_order_service: 'Заказать услугу',
    home_integration_modal_text:
      'Для автоматического выбора и заполнения данных ваших детей при подаче государственной услуги будет отправлено SMS-сообщение для получения вашего согласия на сбор и обработку данных. Это необходимо для ускорения процесса подачи услуги.',
    home_agree: 'Я согласен ',
    home_donAgree: 'Я не согласен',

    home_notification_title: 'Дорогие родители!',
    home_notification_city_text:
      'В соответствии приказу №372 от Министерства просвещения, алгоритм постановки на очередь ребенка и зачисление в ДО изменился для жителей г. Талдыкорган.',
    home_notification_steps_intro: 'Для зачисления ребенка в ДО, необходимо:',
    home_notification_step_1:
      'Подать заявление на очередь, где указано в г. Талдыкорган.',
    home_notification_step_2:
      'Дождаться уведомления о ваучере — оно придет, когда подойдет ваша очередь. (убедитесь, что в способе уведомлений выбран SMS и в корректности номера телефона. Если нет, то не сможем отправлять SMS на ваш номер телефона)',
    home_notification_step_3:
      'После получения SMS, необходимо в течение 2 рабочих дней принять ваучер, выбрав ДО (если не принять ваучер — ваучер аннулируется, а заявление уйдет в стоп-лист).',
    home_notification_step_4:
      'В течение 5 рабочих дней подать документы на зачисление (на 5 день появится возможность продлить срок на два рабочих дня).',
    home_notification_step_5:
      'Если не успеете — ваучер и заявление аннулируются, придется подавать заявление заново.'
  },
  kk: {
    home_title: 'Жетісу облысы Әкімдігінің Электронды қызметтер Порталы',
    home_subtitle: 'Ұсынылатын қызметтер',
    home: 'Басты бет',
    home_support: 'Қолдау қызметі',
    home_frequently_asked_questions: 'Жиі қойылатын сұрақтар',
    home_user_guide: 'Пайдаланушы нұсқаулығы',
    home_user_video: 'Пайдаланушының бейне нұсқаулығы',

    home_insert_title: 'Мемлекеттік қызметті тез, ыңғайлы әрі оңай алыңыз',
    home_insert_text: 'Уақыт пен жүйкеңізді үнемдеңіз',
    home_insert_btn: 'Жеке кабинетке кіру',
    home_order_service: 'Қызметке тапсырыс беру',
    home_integration_modal_text:
      'Мемлекеттік қызметке өтініш беру кезінде балаларыңыздың деректерін автоматты түрде таңдау және толтыру үшін деректерді жинауға және өңдеуге келісім алу мақсатында сізге SMS хабарлама жіберіледі. Бұл өтініш беру процесін жеделдету үшін қажет.',
    home_agree: 'Мен келісемін',
    home_donAgree: 'Мен қарсымын',

    home_notification_title: 'Құрметті ата-аналар!',
    home_notification_city_text:
      'Оқу-ағарту министрлігінің №372 бұйрығына сәйкес, Талдықорған қалаларының тұрғындары үшін баланы кезекке қою және балабақшаға қабылдау алгоритмі өзгерді.',
    home_notification_steps_intro:
      'Баланы балабақшаға қабылдау үшін келесі әрекеттерді орындау қажет:',
    home_notification_step_1:
      'Талдықорған қаласында көрсетілген мекенжай бойынша кезекке тұру үшін өтініш беруді таңдау керек.',
    home_notification_step_2:
      'Ваучер туралы хабарламаны күту — ол сіздің кезегіңіз келген кезде келеді. (Хабарлама алу тәсілінен SMS таңдалғанына және телефон нөміріңіздің дұрыстығына көз жеткізіңіз. Егер бұлар дұрыс болмаса, SMS жібере алмаймыз.)',
    home_notification_step_3:
      'SMS алғаннан кейін 2 жұмыс күні ішінде ваучерді қабылдап, балабақшаны таңдау қажет.(Егер ваучер қабылданбаса — ол жойылады, ал өтініш «стоп-лист» тізіміне жіберіледі.)',
    home_notification_step_4:
      '5 жұмыс күні ішінде құжаттарды тапсыру қажет. (5-ші күні мерзімді қосымша екі жұмыс күніне ұзарту мүмкіндігі ашылады.)',
    home_notification_step_5:
      'Егер үлгермесеңіз — ваучер мен өтініш жойылады, өтінішті қайтадан беру керек болады.'
  }
});
